import axios from 'axios';

// API base URL - production
const API_BASE_URL = 'https://api.segwaycapital.com/api';

console.log('🔗 API Client configured with base URL:', API_BASE_URL);
console.log('📍 Direct URL configured: https://api.segwaycapital.com/api');

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Force refresh the baseURL to ensure it's correct
apiClient.defaults.baseURL = API_BASE_URL;
console.log('🔄 Forced baseURL refresh:', apiClient.defaults.baseURL);

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    // Try registration token first, then regular token
    const registrationToken = localStorage.getItem('registration-token');
    const token = localStorage.getItem('token');
    const authToken = registrationToken || token;
    
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    
    // Add debug logging in development
    if (process.env.NODE_ENV === 'development') {
      console.log('🚀 API Request:', config.method?.toUpperCase(), config.url);
      console.log('🌐 Full URL:', config.baseURL + config.url);
      console.log('📦 Request data:', config.data);
    }
    
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    // Add debug logging in development
    if (process.env.NODE_ENV === 'development') {
      console.log('API Response:', response.config.method?.toUpperCase(), response.config.url, response.data);
    }
    return response;
  },
  (error) => {
    // Add debug logging for errors
    if (process.env.NODE_ENV === 'development') {
      console.error('API Response Error:', error.response?.status, error.response?.data || error.message);
    }
    
    if (error.response?.status === 401) {
      // Don't redirect for subscription-related endpoints as they might not have data yet
      const isSubscriptionEndpoint = error.config?.url?.includes('/investor/load-subscription') || 
                                   error.config?.url?.includes('/investor/save-subscription') ||
                                   error.config?.url?.includes('/investor/submit-subscription');
      
      if (!isSubscriptionEndpoint) {
        localStorage.removeItem('token');
        localStorage.removeItem('registration-token');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient; 